import { useState, useEffect } from "react";
import config from "../config/config";

const useCompanyType = (country) => {
    const [companyTypes, setCompanyTypes] = useState([]);

    useEffect(()=>{
        const fetchCompanyType = async () => {
            try {
                const token = localStorage.getItem("token"); // Retrieve token from localStorage
                const response = await fetch(`${config["backend-url"]}/get_company_types`, {
                    method: "POST",
                    headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json",
                    },
                    body: JSON.stringify({ country: country }),
                });
      
                const data = await response.json();

                if (response.ok) {
                    setCompanyTypes(data);
                  } else if (response.status === 404 && data.message) {
                    console.warn(`⚠️ ${data.message}`);
                  } else {
                    console.error("❌ Failed to fetch regulatory bodies:", data);
                    throw new Error(data.message || "Failed to fetch regulatory bodies");
                  }
            } catch (error) {
                console.error("❌ Error during API call:", error);
            }
        }

        if (country) fetchCompanyType(country);

    },[country]);

    return companyTypes;
}

export default useCompanyType;